
import { useEffect, useRef } from "react"

interface VirtualButtonProps {
    label: React.ReactNode
    onDownHandler: () => void
    onUpHandler: () => void
}

export function VirtualGamepadButton({ label, onDownHandler, onUpHandler }: VirtualButtonProps) {
    const buttonRef = useRef<HTMLButtonElement | null>(null)

    const onDown = (e: PointerEvent) => {
        e.stopPropagation()
        e.preventDefault()
        console.log(`[VGamepad Button ${label}] DOWN (pointer)`, e.pointerId)
        onDownHandler()
    }
  
    const onUp = (e: PointerEvent) => {
        e.stopPropagation()
        console.log(`[VGamepad Button ${label}] UP (pointer)`, e.pointerId)
        onUpHandler()
    }

    // 
    useEffect(() => {
        if (!buttonRef.current) return
        const button = buttonRef.current

        button.addEventListener("pointerdown", onDown, { capture: true })
        button.addEventListener("pointerup", onUp, { capture: true })
        button.addEventListener("pointercancel", onUp, { capture: true })
        // Prevent touch actions from being forwarded to GLS
        button.addEventListener(
            "touchstart",
            (e) => {
                e.preventDefault();
                e.stopPropagation();
                button.classList.add("gamepad-button-pressed");
            },
            { capture: true, passive: false }
        );
   
        button.addEventListener("touchend", (e) => { e.stopPropagation(); }, { capture: true })
        button.addEventListener(
            "touchend",
            (e) => {
                e.stopPropagation();
                button.classList.remove("gamepad-button-pressed");
            },
            { capture: true }
        );

        return () => {
            button.removeEventListener("pointerdown", onDown, { capture: true });
            button.removeEventListener("pointerup", onUp, { capture: true });
            button.removeEventListener("pointercancel", onUp, { capture: true });
        }
        
    }, [])

    return (
        <button 
            ref={buttonRef}
            className="gamepad-button"
        >
            {label}
        </button>
    )
}